<script setup>
import {computed} from "vue";

const siteUrl = document.querySelector('meta[name="site-url"]').content;
const props = defineProps({
  child: {
    type: Object,
    required: true
  }
});

/**
 * 誕生日より子どもの現年齢を返す
 * @type {ComputedRef<unknown>}
 */
const contributorAge = computed(() => {
  //正規表現により生年月日が YYYY-mm-dd 形式か判定し、定型でなければ null を返す
  const matches = /^(\d\d\d\d)-(\d\d)-(\d\d).*?$/.exec(props.child.birthday);

  //定型でなければ 20200101 を基準に仮計算する
  const birthdayString = matches
      ? matches[1]+matches[2]+matches[3]
      : '19900101';

  //本日の日付を得る
  const now = new Date();

  //引き算して返す
  return Math.floor((Number(now.getFullYear().toString().padStart(4, '0')+(now.getMonth() + 1).toString().padStart(2, '0')+now.getDate().toString().padStart(2, '0')) - Number(birthdayString)) / 10000);
});
</script>

<template>
  <li class="lyVerticalCnt lyMr8">
    <p class="lyW16px lyMr4"><img
      :src="siteUrl+(Number(child.sex) === 2 ? 'images/faceGirl.svg' : 'images/faceBoy.svg')"
      width="16"
      height="16"
      :alt="Number(child.sex) === 2 ? '女の子：' : '男の子：'"
    ></p>
    <p class="pFont12 pFontMedium">{{contributorAge}}才</p>
  </li>
</template>
